export default "__VITE_ASSET__Bhdt89k$__"